import {AUTH_TARGETS} from './context/MapAuthProvider.jsx';

export const DEFAULT_ZOOM = 2;
export const MAX_ZOOM = 20;

export const STILES_HOSTNAME = {
  [AUTH_TARGETS.PROD]: 'https://tiles{0-3}.planet.com',
  [AUTH_TARGETS.STAGING]: 'https://yats.staging.planet-labs.com',
};

export const STILES_LAYER_BASE_URL =
  '/basemaps/v1/stile/global/{z}/{x}/{y}.png';

export const BASE_LAYERS = {
  SATELLITE: 'satellite',
  DARK: 'dark',
  LIGHT: 'light',
};

export const BASE_LAYERS_STYLES = {
  [BASE_LAYERS.DARK]: {
    background: 'mapbox://styles/planet/ck8yzkkra05tv1ip9os6pmi1e',
    labels: 'mapbox://styles/planet/ck9qfizat2wz81ip84e3ac018',
  },
  [BASE_LAYERS.LIGHT]: {
    background: 'mapbox://styles/planet/clu7p4c73008l01ra8lzr9qlo',
    labels: 'mapbox://styles/planet/clu7p6so002f401ptf4b0d76g',
  },
  [BASE_LAYERS.SATELLITE]: {
    background: (authTarget, token) => {
      return token
        ? `${STILES_HOSTNAME[authTarget]}${STILES_LAYER_BASE_URL}?token=${token}`
        : 'https://stile{0-3}.planet.com/styles/mosaic-base/{z}/{x}/{y}.jpg';
    },
    labels: 'mapbox://styles/planet/ck9qfizat2wz81ip84e3ac018',
  },
};
